var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "share-wrapper" }, [
    _c("img", {
      staticClass: "logo",
      attrs: { src: require("../../../static/images/logos.png") }
    }),
    _vm._v(" "),
    _c("p", { staticClass: "clock_in" }, [_vm._v("坚持打卡天数")]),
    _vm._v(" "),
    _c("p", { staticClass: "clock_days" }, [_vm._v(_vm._s(_vm.data.days))]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("p", { staticClass: "sentence" }, [
        _c("span", { staticClass: "quotation" }, [_vm._v("“")]),
        _vm._v(_vm._s(_vm.data.sentence))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "head_img" }, [
        _c("img", { attrs: { src: _vm.data.headPortrait, alt: "" } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "learn_data" }, [
        _c("p", { staticClass: "lesson" }, [_vm._v(_vm._s(_vm.data.shareTxt))]),
        _vm._v(" "),
        _c("div", { staticClass: "data_statistics" }, [
          _c("div", [
            _c("p", [_vm._v("今日学习")]),
            _vm._v(" "),
            _c("p", [
              _c("span", { staticClass: "num" }, [
                _vm._v(_vm._s(_vm.data.todayMinutes))
              ]),
              _vm._v("分钟")
            ])
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "borders" }),
          _vm._v(" "),
          _c("div", [
            _c("p", [_vm._v("超越用户")]),
            _vm._v(" "),
            _c("p", [
              _c("span", { staticClass: "num" }, [
                _vm._v(_vm._s(_vm.data.proportion))
              ]),
              _vm._v("%")
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "share_detail" }, [
      _c("img", { staticClass: "share_qr", attrs: { src: _vm.data.shareQr } }),
      _vm._v(" "),
      _c("div", [
        _c("p", { staticClass: "share_title" }, [
          _vm._v(_vm._s(_vm.data.shareTitle))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "share_cont" }, [
          _vm._v(_vm._s(_vm.data.shareContent))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "share_note" }, [
          _vm._v(_vm._s(_vm.data.shareNote))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c35c154", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c35c154","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/share.vue
// module id = null
// module chunks = 